// @components
import { Collapse } from "antd";
import { useContext } from "react";
import Context from "context/appContext";
import Check from "../../../assets/images/check-circle-c2.svg";
//@utils
import { formatPrice } from "utils/utils";

// collapsable de las coberturas por planes
export default function CollapseComponent() {
  const { sidebarData } = useContext(Context);

  return (
    <Collapse className="ant-collapse-generic" defaultActiveKey={["1"]}>
      {sidebarData &&
        sidebarData.map((data) => (
          <>
            {data &&
              data.items.map((item, index) => (
                <Collapse.Panel
                  header={
                    <div className="ant-collapse-header-description">
                      <span>{item.title ? item.title : ""}</span>
                      <p>
                        {item.price
                          ? formatPrice(item.price)
                          : item.value
                          ? item.value
                          : ""}
                      </p>
                    </div>
                  }
                  key={item.key}
                >
                  <ul className="list-plans">
                    {item &&
                      item.values.map((val) => (
                        <>
                          <li className={`${val.value ? "" : "custom-width"}`}>
                            <p>{val.label}</p>
                            <p title={val.value.length > 16 ? val.value : ""}>
                              {val.value ? (
                                typeof val.value === "number" ? (
                                  formatPrice(val.value)
                                ) : (
                                  val.value
                                )
                              ) : (
                                <img src={Check} alt="Imagen check" />
                              )}
                            </p>
                          </li>
                        </>
                      ))}
                  </ul>
                </Collapse.Panel>
              ))}
          </>
        ))}
    </Collapse>
  );
}
